import courseConfig from '../config/course';

const API_URL = courseConfig.apiUrl;

export async function initPayment({ email, name, currency }) {
  const response = await fetch(`${API_URL}/v1/payments/init`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      courseId: courseConfig.courseId,
      email,
      name,
      currency
    })
  });

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error?.message || 'Failed to initialize payment');
  }
  return data.data;
}

export async function verifyPayment(txRef) {
  const response = await fetch(`${API_URL}/v1/payments/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      txRef,
      courseId: courseConfig.courseId
    })
  });

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error?.message || 'Failed to verify payment');
  }
  return data.data;
}
